import React, { useEffect, useState } from "react";
import "./userProfile.scss";
import TwoBreadcrumb from "../../../components/breadcrumbs/TwoBreadcrumb";
import { useParams } from "react-router-dom";
import { Button, Grid, Skeleton, Stack } from "@mui/material";
import dateFormat from "dateformat";

// Images
import cover from "../../../assets/cover.jpg";
import avatar_male from "../../../assets/avatar_male.jpg";
import avatar_female from "../../../assets/avatar_female.jpg";
import avatar_unknown from "../../../assets/avatar_unknown.jpg";

// Icons
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import WcRoundedIcon from "@mui/icons-material/WcRounded";
import ManRoundedIcon from "@mui/icons-material/ManRounded";
import Woman2RoundedIcon from "@mui/icons-material/Woman2Rounded";
import CakeRoundedIcon from "@mui/icons-material/CakeRounded";
import orderStore from "../../../stores/orderStore";
import UserOrderCard from "../../../components/userOrderCard/UserOrderCard";
import orderDeliveryStatusTimeStore from "../../../stores/orderDeliveryStatusTimeStore";
import productRatingStore from "../../../stores/productRatingStore";
import addressStore from "../../../stores/addressStore";
import usersStore from "../../../stores/usersStore";
import UserOrderCardSkeleton from "../../../components/userOrderCard/UserOrderCardSkeleton";
import sidebarActivePage from "../../../stores/sidebarActivePage";

const UserProfile = () => {
  const SidebarActivePage = sidebarActivePage();
  const params = useParams();
  const OrderStore = orderStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const ProductRatingStore = productRatingStore();
  const AddressStore = addressStore();
  const UsersStore = usersStore();

  const [totalOrder, setTotalOrder] = useState(null);
  const [userData, setUserData] = useState(null);
  const [userAddressData, setUserAddressData] = useState(null);
  const [loadAddress, setLoadAddress] = useState(2);

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Users" });
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    setAllDate();
  }, [OrderStore.isLoading, AddressStore.isLoading, UsersStore.isLoading]);

  const setAllDate = () => {
    if (
      !OrderStore.isLoading &&
      !AddressStore.isLoading &&
      !UsersStore.isLoading
    ) {
      UsersStore.allUser.map((item) => {
        if (item._id === params.id) {
          setUserData(item);
        }
      });

      const userTotalOrder = [];
      OrderStore.orderDetail.map((item) => {
        if (item.userID === params.id) {
          userTotalOrder.push(item._id);
        }
      });
      setTotalOrder(userTotalOrder.length);

      const userAddresses = [];
      AddressStore.userAddress.map((item) => {
        if (item.userID === params.id) {
          userAddresses.push(item);
        }
      });
      setUserAddressData(userAddresses);
    }
  };

  const loadMoreOrLessAddress = () => {
    if (loadAddress === userAddressData.length) {
      setLoadAddress(2);
    } else {
      setLoadAddress(userAddressData.length);
    }
  };

  return (
    <div className="user-profile">
      <div className="heading">Profile</div>
      <TwoBreadcrumb
        mainName="Users"
        mainLink="users"
        activeName={`Profile - ${params.username}`}
      />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <div className="top-part">
            <img src={cover} alt="" className="cover-img" />
            <div className="user-img-container">
              {userData ? (
                userData.gender ? (
                  userData.gender === "M" ? (
                    <img src={avatar_male} alt="" className="user-img" />
                  ) : (
                    <img src={avatar_female} alt="" className="user-img" />
                  )
                ) : (
                  <img src={avatar_unknown} alt="" className="user-img" />
                )
              ) : (
                <Skeleton
                  animation="wave"
                  variant="circular"
                  sx={{ bgcolor: "var(--grayText)" }}
                  component="img"
                  className="user-img"
                />
              )}
            </div>
            <div className="user-name-email">
              <div className="username">{params.username}</div>
              <div className="email">
                {userData ? (
                  userData.email
                ) : (
                  <Skeleton
                    animation="wave"
                    width="70%"
                    sx={{ bgcolor: "var(--grayText)" }}
                  />
                )}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="total-order">
                  <div className="order-count">
                    {totalOrder ? (
                      totalOrder
                    ) : (
                      <Skeleton animation="wave" width="30%" />
                    )}
                  </div>
                  <div className="order-title">Total Order</div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="user-about">
                  <div className="title">About</div>
                  <Stack className="about-content" spacing={2}>
                    <div className="item">
                      <Stack spacing={2} direction="row">
                        <EmailRoundedIcon className="icon" />{" "}
                        <span>
                          {userData ? (
                            userData.email
                          ) : (
                            <Skeleton animation="wave" width="60%" />
                          )}
                        </span>
                      </Stack>
                    </div>
                    <div className="item">
                      <Stack spacing={2} direction="row">
                        <PhoneRoundedIcon className="icon" />{" "}
                        <span>
                          {userData ? (
                            userData.phoneNumber
                          ) : (
                            <Skeleton animation="wave" width="60%" />
                          )}
                        </span>
                      </Stack>
                    </div>
                    <div className="item">
                      <Stack spacing={2} direction="row">
                        {userData ? (
                          userData.gender ? (
                            userData.gender === "M" ? (
                              <ManRoundedIcon className="icon" />
                            ) : (
                              <Woman2RoundedIcon className="icon" />
                            )
                          ) : (
                            <WcRoundedIcon className="icon" />
                          )
                        ) : (
                          <WcRoundedIcon className="icon" />
                        )}

                        <span>
                          {userData ? (
                            userData.gender ? (
                              userData.gender === "M" ? (
                                "Male"
                              ) : (
                                "Female"
                              )
                            ) : (
                              "-"
                            )
                          ) : (
                            <Skeleton animation="wave" width="30%" />
                          )}
                        </span>
                      </Stack>
                    </div>
                    <div className="item">
                      <Stack spacing={2} direction="row">
                        <CakeRoundedIcon className="icon" />{" "}
                        <span>
                          {userData ? (
                            userData.dateOfBirth ? (
                              dateFormat(
                                new Date(userData.dateOfBirth),
                                "mmm dd, yyyy"
                              )
                            ) : (
                              "-"
                            )
                          ) : (
                            <Skeleton animation="wave" width="60%" />
                          )}
                        </span>
                      </Stack>
                    </div>
                  </Stack>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="user-addresses">
                  <div className="title">Address</div>
                  <Stack spacing={2} className="address-content">
                    {userAddressData ? (
                      userAddressData.slice(0, loadAddress).map((item) => (
                        <div className="single-address" key={item._id}>
                          <div className="address-username">
                            {item.fullName}
                          </div>
                          <div className="address-of-user">
                            {item.address}, {item.city} - {item.pincode}
                          </div>
                          <div className="address-state-country">
                            {item.state}, {item.country}
                          </div>
                          <div className="address-contact-no">
                            {item.phoneNumber}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="single-address">
                        <div className="address-username">
                          <Skeleton animation="wave" width="70%" />
                        </div>
                        <div className="address-of-user">
                          <Skeleton animation="wave" width="100%" />
                        </div>
                        <div className="address-state-country">
                          <Skeleton animation="wave" width="40%" />
                        </div>
                        <div className="address-contact-no">
                          <Skeleton animation="wave" width="60%" />
                        </div>
                      </div>
                    )}

                    {userAddressData && userAddressData.length > 2 && (
                      <Button
                        className="btn-load-more"
                        onClick={loadMoreOrLessAddress}
                      >
                        {loadAddress === userAddressData.length
                          ? "Show Less"
                          : "Show More"}
                      </Button>
                    )}
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Stack spacing={2} className="user-order-list">
            {OrderStore.isLoading ||
            OrderDeliveryStatusTimeStore.isLoading ||
            ProductRatingStore.isLoading ? (
              <UserOrderCardSkeleton />
            ) : (
              OrderStore.orderDetail &&
              OrderStore.orderDetail
                .slice(0)
                .reverse()
                .map((item) => {
                  if (item.userID === params.id) {
                    return <UserOrderCard item={item} key={item._id} />;
                  }
                })
            )}
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default UserProfile;
